import React from "react";
import camelcaseKeys from "camelcase-keys";
import { getQueryParams } from "./utils";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class KmReadingAPI extends React.Component {
    constructor() {
        super(...arguments);
        this.callAPI = async (method, action, params) => {
            const { token } = this.props;
            const useBodyContent = method !== "GET" && method !== "HEAD";
            const finalUrl = useBodyContent
                ? `/api/km-reading/${action}`
                : `/api/km-reading/${action}?${getQueryParams(params)}`;
            const response = await fetch(finalUrl, {
                method,
                headers: token ? new Headers({ Authorization: token }) : undefined,
                credentials: "include", // Include session cookie
                body: useBodyContent
                    ? new Blob([JSON.stringify(params)], { type: "application/json" })
                    : null
            });
            const data = await response.json();
            return camelcaseKeys(data);
        };
        this.handleSendMessage = async (params) => {
            try {
                var response = await fetch(legacyApiResourceUrl("Message/RunExternalDistributionMatrix"), {
                    method: "POST",
                    credentials: "include", // Include session cookie
                    body: new Blob([JSON.stringify(params)], { type: "application/json" })
                });
                return response.json();
            }
            catch (err) {
                throw Error("Error when searching vendors. " + err.message);
            }
        };
        this.handleSearch = async ({ carRegistrationNo, fromDate, toDate, vendor, backofficeId }) => {
            try {
                const response = await this.callAPI("GET", "search-object", {
                    CarRegistrationNo: carRegistrationNo,
                    ContractEndDateFrom: fromDate,
                    ContractEndDateTo: toDate,
                    VendorOrganizationNo: vendor,
                    VendorBackofficeNo: backofficeId
                });
                return {
                    ...response,
                    list: response.list.map((x) => ({
                        ...x,
                        ContractEndDate: new Date(x.ContractEndDate)
                    }))
                };
            }
            catch (err) {
                throw Error("Error searching km reading object. " + err.message);
            }
        };
        this.handlegetCalculationDetails = async (carRegistrationNo, vendor) => {
            try {
                const response = await this.callAPI("GET", "calculation-details", {
                    carRegistrationNo,
                    vendor
                });
                return response;
            }
            catch (err) {
                throw Error("Error searching km reading object. " + err.message);
            }
        };
        this.handleRegister = async ({ contractNo, reading, readingDate, priceExtraKm, customerName, registrationNo, invoiceAmount, objectType, deliveryDate, distanceKm, allowedKm, emailComment }) => {
            try {
                const response = await this.callAPI("PUT", "register", {
                    contractNo,
                    kmReading: reading,
                    kmReadingDate: readingDate,
                    priceExtraKm,
                    customerName,
                    registrationNo,
                    invoiceAmount,
                    objectType,
                    deliveryDate,
                    distanceKm,
                    allowedKm,
                    emailComment
                });
                return response;
            }
            catch (err) {
                throw Error("Error registering km reading. " + err.message);
            }
        };
        this.handleSearchVendor = async (searchString) => {
            try {
                var response = await fetch(legacyApiResourceUrl(`/VendorSelect/SearchVendorsByPartialName?data=${encodeURIComponent(searchString)}`), {
                    method: "GET",
                    credentials: "include" // Include session cookie
                });
                const data = await response.json();
                return camelcaseKeys(data);
            }
            catch (err) {
                throw Error("Error when searching vendors. " + err.message);
            }
        };
    }
    render() {
        const { children } = this.props;
        return children({
            search: this.handleSearch,
            register: this.handleRegister,
            vendorSearch: this.handleSearchVendor,
            getCalculationDetails: this.handlegetCalculationDetails,
            sendMessage: this.handleSendMessage
        });
    }
}
export default KmReadingAPI;
//# sourceMappingURL=KmReadingAPI.js.map